/*jslint browser */
/*global process */

import Storage from "../model/storage/storage";

var $ = jQuery;

/**
 *
 */
export default class ProductStorageController
{
    private _addToStorage: JQuery;
    private _storage: Storage;

    constructor()
    {
        this._storage = new Storage();
    }

    public storageAction(): void
    {
        this.registerEvents();
        this._storage.init();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._addToStorage = $('.add-to-storage');

        this._addToStorage.on('click', (e) => {
            this.addToStorageClick($(e.currentTarget));
        })
    }

    private addToStorageClick(ob: JQuery)
    {
        this._storage.addProduct(ob);
        this._addToStorage.text('Dodano!');
    }
}